import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { useTranslation } from 'react-i18next'
import { showAlert } from '../../../utility/SweetAlert'
import { DATA_NOT_EXIST } from '../../../utility/ResponseConstant'
import { removeCookies, setCookies } from '../../../utility/Cookies'
import { useDispatch } from 'react-redux'
import { FetchSeller } from '../../../redux/seller/actionCreator'
import { encryptCrypto } from '../../../utility/Encryption'

const InteractorStoreAccountView = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const viewAccount = useCallback(
    (payload) => {
      const { source = 'login', ...body } = payload
      payload = {
        ...body,
        source: 'CMS',
      }
      ApiService.jsonRequest('/store-account/view', payload, (response) => {
        if (response.status_code === 200) {
          if (source !== 'profile')
            showAlert({ icon: 'success', message: t(`message.${source}_successful`), timer: 2000 })
          setCookies({
            key: '_wssc',
            value: encryptCrypto(JSON.stringify(response.data)),
            expires: new Date().getTime() + 8 * 3600 * 1000, // 8 Hours
          })
          setCookies({
            key: '_wchat',
            value: encryptCrypto(
              JSON.stringify({
                reference_uid: response.data.uid,
                role: 'SELLER',
                full_name: response.data.store_name,
                profile_picture: response.data.store_logo ?? '',
              }),
            ),
            expires: new Date().getTime() + 8 * 3600 * 1000, // 8 Hours
          })
          dispatch(FetchSeller(response.data))
          if (source !== 'profile') window.location = '/'
        } else {
          switch (response.messages) {
            case DATA_NOT_EXIST:
              showAlert({
                icon: 'error',
                message: t(`response_message.store_not_exist`),
                timer: 4000,
                redirect: '/account/signin',
              })

              removeCookies('_wsso')
              removeCookies('_wssc')
              removeCookies('_wchat')
              removeCookies('wsc-summary-header')
              break
            default:
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 2000,
              })
              break
          }
        }
      })
    },
    [dispatch, t],
  )

  const sellerView = useCallback(
    (payload, loadingCallback = () => {}, callback = () => {}) => {
      const requestPayload = {
        ...payload,
        source: 'CMS',
      }
      loadingCallback(true)
      ApiService.jsonRequest('/store-account/view', requestPayload, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          callback(response.data)
          setCookies({
            key: '_wssc',
            value: encryptCrypto(JSON.stringify(response.data)),
            expires: new Date().getTime() + 8 * 3600 * 1000, // 8 Hours
          })
          setCookies({
            key: '_wchat',
            value: encryptCrypto(
              JSON.stringify({
                reference_uid: response.data.uid,
                role: 'SELLER',
                full_name: response.data.store_name,
                profile_picture: response.data.store_logo ?? '',
              }),
            ),
            expires: new Date().getTime() + 8 * 3600 * 1000, // 8 Hours
          })
          dispatch(FetchSeller(response.data))
        } else {
          callback({})
          switch (response.messages) {
            case DATA_NOT_EXIST:
              // window.location = '/store/register'
              break
            default:
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 2000,
              })
              break
          }
        }
      })
    },
    [dispatch, t],
  )

  return { viewAccount, sellerView }
}

export default InteractorStoreAccountView
